/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectDailyTaskCommand } from '../../models/create-project-daily-task-command';
import { CreateProjectDailyTaskCommandResult } from '../../models/create-project-daily-task-command-result';

export interface ApiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Params {
      body?: CreateProjectDailyTaskCommand
}

export function apiProjectDailyExpectedTasksCreateProjectDailyTaskPost(http: HttpClient, rootUrl: string, params?: ApiProjectDailyExpectedTasksCreateProjectDailyTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectDailyTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyExpectedTasksCreateProjectDailyTaskPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectDailyTaskCommandResult>;
    })
  );
}

apiProjectDailyExpectedTasksCreateProjectDailyTaskPost.PATH = '/api/ProjectDailyExpectedTasks/CreateProjectDailyTask';
